import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';


const Modal = ({
  show,
  onClose,
  title,
  children,
  maxWidth,
  hideActions = false,
  showCloseIcon = true,
}) => {
  return (
      // You can set this to 'xs', 'sm', 'md', 'lg', 'xl' or false
      <Dialog open={show} onClose={onClose} fullWidth={true} maxWidth={maxWidth}>
      <DialogTitle sx={{ position: 'relative', pr: showCloseIcon ? 6 : 2 }}>{title}
        {showCloseIcon && (
          <IconButton
            aria-label="Close"
            onClick={onClose}
            size="small"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>close</span>
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      {!hideActions && (
        <DialogActions>
          <Button onClick={onClose} color="primary">Close</Button>
        </DialogActions>
      )}
    </Dialog>
    
  );
};

export { Modal };
